var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('a',{attrs:{"href":"/"}},[_c('h2',{staticClass:"title is-2 p-05"},[_vm._v(_vm._s(_vm.conf.website_name))])])]),_c('div',{staticClass:"column"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }